import * as React from 'react'
import g from 'glamorous'
import { Alert } from 'react-bootstrap'

import ForgotPasswordForm from './forgotPassword/ForgotPasswordForm'
import Headline from '../components/Headline'
import Loading from '../components/Loading'
import RequestPasswordLinkMutation from '../components/mutations/RequestPasswordLinkMutation'

export interface ForgotPasswordProps {}

const StyledContainer = g.div(({ theme }) => {
  return {
    maxWidth: '600px',
    width: '100%',
    margin: '0 auto'
  }
})

const ForgotPassword: React.SFC<ForgotPasswordProps> = () => {
  return (
    <StyledContainer>
      <Headline>Žádost o změnu hesla</Headline>
      <RequestPasswordLinkMutation>
        {(requestPassword, { data, called, error, loading }) => {
          if (loading) {
            return <Loading />
          }

          if (called && error == null) {
            return <Alert bsStyle="success">Žádost odeslána</Alert>
          }

          return (
            <div>
              {error != null && (
                <Alert bsStyle="error">
                  Při vašem požadavku nastala chyba.
                </Alert>
              )}
              <ForgotPasswordForm
                onSubmit={async ({ email }) => {
                  const result = await requestPassword({ variables: { email } })

                  if (result == null || result.data == null) {
                    return
                  }
                }}
              />
            </div>
          )
        }}
      </RequestPasswordLinkMutation>
    </StyledContainer>
  )
}

export default ForgotPassword



// WEBPACK FOOTER //
// ./src/screens/ForgotPassword.tsx